var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5291 7.77196C17.4591 7.76196 17.3891 7.76196 17.3191 7.77196C15.7691 7.72196 14.5391 6.45195 14.5391 4.89195C14.5391 3.30195 15.8291 2.00195 17.4291 2.00195C19.0191 2.00195 20.3191 3.29195 20.3191 4.89195C20.3091 6.45195 19.0791 7.72196 17.5291 7.77196Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.7916 14.7023C19.6716 15.4523 18.1016 15.7323 16.6516 15.5423C17.0316 14.7223 17.2316 13.8124 17.2416 12.8524C17.2416 11.8524 17.0216 10.9024 16.6016 10.0724C18.0816 9.87236 19.6516 10.1523 20.7816 10.9023C22.3616 11.9423 22.3616 13.6523 20.7916 14.7023Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.43843 7.77196C6.50843 7.76196 6.57844 7.76196 6.64844 7.77196C8.19844 7.72196 9.42844 6.45195 9.42844 4.89195C9.42844 3.30195 8.13844 2.00195 6.53844 2.00195C4.94844 2.00195 3.64844 3.29195 3.64844 4.89195C3.65844 6.45195 4.88843 7.72196 6.43843 7.77196Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.55109 12.8525C6.55109 13.8225 6.76109 14.7426 7.14109 15.5726C5.73109 15.7226 4.26109 15.4225 3.18109 14.7125C1.60109 13.6625 1.60109 11.9525 3.18109 10.9025C4.25109 10.1825 5.76109 9.89255 7.18109 10.0525C6.77109 10.8925 6.55109 11.8425 6.55109 12.8525Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1208 15.8719C12.0408 15.8619 11.9508 15.8619 11.8608 15.8719C10.0208 15.8119 8.55078 14.302 8.55078 12.442C8.55078 10.542 10.0808 9.00195 11.9908 9.00195C13.8908 9.00195 15.4308 10.542 15.4308 12.442C15.4308 14.302 13.9708 15.8119 12.1208 15.8719Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87078 17.9426C7.36078 18.9526 7.36078 20.6126 8.87078 21.6126C10.5908 22.7626 13.4108 22.7626 15.1308 21.6126C16.6408 20.6026 16.6408 18.9426 15.1308 17.9426C13.4208 16.7926 10.6008 16.7926 8.87078 17.9426Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.e81374a2e93181c43a52067ca2250783.svg";
export { ForwardRef as ReactComponent };